import api from "./axiosInstance";
import { baseURL, createHeaders } from "./constants";

const creditsPerApi = async (params) => {
  const { id } = params;
  return api.get(`${baseURL}/companies?populate=*&filters[id]=${id}`, {
    headers: createHeaders()
  });
};

export { creditsPerApi };

const totalCreditsAndRemaining = async (token) => {
  return api.get(`${baseURL}/v2/dashboard-summary`, {
    headers: createHeaders()
  });
};

export { totalCreditsAndRemaining };


const activePlansSummary = async (params) => {
  const { id } = params;
  return api.get(`${baseURL}/assign-credits?populate=*&filters[status]=ACTIVE&filters[company][id]=${id}`, {
    headers: createHeaders() });
};

export { activePlansSummary };

const creditAnalytics = async () => {
  return api.get(`${baseURL}/credit-analytics`, {
    headers: createHeaders()
  });
};

export { creditAnalytics };
